import {
  GET_LEGALFRACTION,
  GET_LEGALFRACTION_SUCCESS,
  GET_LEGALFRACTION_FAIL,
  DELETE_LEGALFRACTION,
  DELETE_LEGALFRACTION_SUCCESS,
  DELETE_LEGALFRACTION_FAIL,
  UPDATE_LEGALFRACTION,
  UPDATE_LEGALFRACTION_SUCCESS,
  UPDATE_LEGALFRACTION_FAIL,
  ADD_NEW_LEGALFRACTION,
  ADD_LEGALFRACTION_SUCCESS,
  ADD_LEGALFRACTION_FAIL,
  LEGALFRACTION_LOADING,
  LEGALFRACTION_RESET
} from "./actionType";

export const resetLegalFractionState = (actionType) => ({
  type: LEGALFRACTION_RESET,
  payload: { actionType },
});

export const getLegalFractionSuccess = (actionType, data) => ({
  type: GET_LEGALFRACTION_SUCCESS,
  payload: { actionType, data },
});

export const getLegalFractionFail = (actionType, error) => ({
  type: GET_LEGALFRACTION_FAIL,
  payload: { actionType, error },
});

export const getLegalFraction = data => ({
  type: GET_LEGALFRACTION,
  payload: data,
});

export const getLegalFractionLoading = () => ({
  type: LEGALFRACTION_LOADING
});

export const deleteLegalFraction = data => ({
  type: DELETE_LEGALFRACTION,
  payload: data,
});

export const deleteLegalFractionSuccess = data => ({
  type: DELETE_LEGALFRACTION_SUCCESS,
  payload: data,
});

export const deleteLegalFractionFail = error => ({
  type: DELETE_LEGALFRACTION_FAIL,
  payload: error,
});

export const updateLegalFraction = data => ({
  type: UPDATE_LEGALFRACTION,
  payload: data,
});

export const updateLegalFractionFail = error => ({
  type: UPDATE_LEGALFRACTION_FAIL,
  payload: error,
});

export const updateLegalFractionSuccess = data => ({
  type: UPDATE_LEGALFRACTION_SUCCESS,
  payload: data,
});

export const addNewLegalFraction = data => ({
  type: ADD_NEW_LEGALFRACTION,
  payload: data,
});

export const addLegalFractionSuccess = data => ({
  type: ADD_LEGALFRACTION_SUCCESS,
  payload: data,
});

export const addLegalFractionFail = error => ({
  type: ADD_LEGALFRACTION_FAIL,
  payload: error,
});